import React, { useState } from "react";
import "./css/StandardsCatalogue.css";
import { standardsCatalogueData } from "./standardsCatalogueData";

const StandardsCatalogue = () => {
  const [search, setSearch] = useState("");
  
  const [showModal, setShowModal] = useState(false);
  const [selectedStandard, setSelectedStandard] = useState(null);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Filtered standards
  const query = search.trim().toLowerCase();
  const filteredStandards = !query
    ? standardsCatalogueData
    : standardsCatalogueData.filter(s =>
        s.code.toLowerCase().includes(query) ||
        s.title.toLowerCase().includes(query) ||
        s.description.toLowerCase().includes(query)
      );

  // Pagination calculations
  const totalPages = Math.ceil(filteredStandards.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentStandards = filteredStandards.slice(startIndex, startIndex + itemsPerPage);

  const goToPage = (page) => {
    if (page < 1) page = 1;
    else if (page > totalPages) page = totalPages;
    setCurrentPage(page);
  };

  const openModal = (standard) => {
    setSelectedStandard(standard);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedStandard(null);
  };

  return (
    <div className="container">
      {/* Header */}
      <div className="header text-center catalogueBG" style={{ padding: "130px 0" }}>
        <h1 className="text-white animate-heading">Buy Malawi Standards Today!</h1>
      </div>
      <br />

 {/* Sidebar */}
 <div className="col-md-3">
          <h4>OUR STANDARDS</h4>
          <input
            type="text"
            className="form-control"
            placeholder="Search by MS Number, Title or Description"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1); // reset page
            }}
          />
        </div>

      <div className="row mt-4">
       

        {/* Table */}
        <div className="col-md-12">
          <table className="table table-striped table-hover">
            <thead>
              <tr>
                <th>MS NUMBER</th>
                <th>TITLE</th>
                <th>SECTOR</th>
                <th>DATE GAZETTED</th>
                <th>STATUS OF IMPLEMENTATION</th>
                <th>NUMBER OF PAGES</th>
                <th>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {currentStandards.map((s, i) => (
                <tr key={i}>
                  <td
                    className="open-modal"
                    style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
                    onClick={() => openModal(s)}
                  >
                    {s.code}
                  </td>
                  <td
                    className="open-modal"
                    style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
                    onClick={() => openModal(s)}
                  >
                    {s.title}
                  </td>
                  <td>{s.sector}</td>
                  <td>{s.date_gazetted}</td>
                  <td>{s.status}</td>
                  <td>{s.pages}</td>
                  <td>
                    <button
                      style={{
                        backgroundColor: "#ff6600",
                        color: "white",
                        border: "none",
                        borderRadius: "20px",
                        padding: "6px 16px",
                        fontWeight: "bold",
                        cursor: "pointer",
                      }}
                      onClick={() => window.open("http://192.168.0.5:3005", "_blank")}
                    >
                      Buy Standard
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="d-flex justify-content-between align-items-center mt-3">
              <button
                className="btn btn-outline-primary"
                onClick={() => goToPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span>Page {currentPage} of {totalPages}</span>
              <button
                className="btn btn-outline-primary"
                onClick={() => goToPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          )}

          {/* Modal */}
          {showModal && selectedStandard && (
            <div
              className="modal-overlay"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
              }}
              onClick={closeModal}
            >
              <div
                className="modal-content bg-white p-4 rounded"
                style={{
                  width: "50%",
                  maxWidth: "600px",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.3)"
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <p style={{ fontWeight: "bold", fontSize: "18px" }}>{selectedStandard.code}</p>
                <p style={{ fontWeight: "500", fontSize: "16px" }}>{selectedStandard.title}</p>
                <p style={{ margin: "10px 0" }}>{selectedStandard.description}</p>
                <p><strong>Sector:</strong> {selectedStandard.sector}</p>
                <p><strong>Date gazetted:</strong> {selectedStandard.date_gazetted}</p>
                <p><strong>Status of implementation:</strong> {selectedStandard.status}</p>
                <p><strong>Number of pages:</strong> {selectedStandard.pages}</p>
                <div className="text-center mt-4">
                  <button
                    onClick={closeModal}
                    style={{
                      backgroundColor: "#FF6600",
                      color: "white",
                      border: "none",
                      borderRadius: "5px",
                      padding: "6px 16px",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default StandardsCatalogue;
